export default "__VITE_PUBLIC_ASSET__6866eb80__"